module.exports = __webpack_public_path__ + "img/A58A0441_min.258b36c0.jpg";